module.exports = __webpack_public_path__ + "a6b85734a197a636deed88fe4b64f49a.pdf";